module.exports = __webpack_public_path__ + "img/NivelLiquidoGreen.701376d8.svg";